/**
 * The `aria-live` status region. `aria-busy` carries no message and announces
 * unreliably, so it is not a substitute. Two regions: polite (`role="status"`) for
 * benign updates and assertive (`role="alert"`) for errors, so an error interrupts
 * the SR queue while a count change waits its turn. `sr-only` — announcement channel, not chrome.
 */
export type TableLiveRegionProps = {
  /** The polite message (loaded / selection count). Empty string = nothing to announce. */
  polite: string
  /** The assertive message (error / load-more failure). Empty string = nothing to announce. */
  assertive: string
}

export const TableLiveRegion = ({ polite, assertive }: TableLiveRegionProps) => (
  <>
    <div
      aria-atomic="true"
      aria-live="polite"
      className="sr-only"
      data-table-live="polite"
      role="status"
    >
      {polite}
    </div>
    <div
      aria-atomic="true"
      aria-live="assertive"
      className="sr-only"
      data-table-live="assertive"
      role="alert"
    >
      {assertive}
    </div>
  </>
)
